import { render, staticRenderFns } from "./LayoutVertical.vue?vue&type=template&id=ed89ee64&scoped=true&"
import script from "./LayoutVertical.vue?vue&type=script&lang=js&"
export * from "./LayoutVertical.vue?vue&type=script&lang=js&"
import style0 from "./LayoutVertical.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./LayoutVertical.vue?vue&type=style&index=1&id=ed89ee64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed89ee64",
  null
  
)

export default component.exports